export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/propagation.worker.cbabffe8.worker.js");
}
